import { TFunction } from "i18next";
import * as Yup from "yup";

import { MAX_USER_CODE_LENGTH, UserCodePattern } from "./CounselorPersonalData.types";

export function counselorPersonalDataValidationSchema(t: TFunction) {
  return Yup.object().shape({
    userCode: Yup.string()
      .trim()
      .required(t("common.validation.fieldRequired", { fieldName: t("counselors.fields.kzz") }))
      .matches(UserCodePattern, {
        message: t("counselors.personalData.validation.invalidUserCode"),
        excludeEmptyString: true,
      })
      .max(MAX_USER_CODE_LENGTH, ({ max }) => t("common.validation.maxLength", { max })),
    team: Yup.string().nullable(),
    isTeamLeader: Yup.boolean()
      .nullable()
      .required(t("common.validation.fieldRequired", { fieldName: t("counselors.fields.teamLeader") })),
    mobileNumber: Yup.string(),
    phoneExtension: Yup.string(),
  });
}
